'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECENT_HOME = exports.RECEIVE_HOME = exports.REQUEST_HOME = exports.RECEIVE_HOMES = exports.REQUEST_HOMES = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.fetchHomesIfNeeded = fetchHomesIfNeeded;
exports.addRecentHome = addRecentHome;

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_HOMES = exports.REQUEST_HOMES = 'REQUEST_HOMES';
var RECEIVE_HOMES = exports.RECEIVE_HOMES = 'RECEIVE_HOMES';
var REQUEST_HOME = exports.REQUEST_HOME = 'REQUEST_HOME';
var RECEIVE_HOME = exports.RECEIVE_HOME = 'RECEIVE_HOME';
var RECENT_HOME = exports.RECENT_HOME = 'RECENT_HOME';

var isServer = !!process.env.REACT_APP_SERVER;

function requestHomes(builderId) {
  return {
    type: REQUEST_HOMES,
    builderId: builderId
  };
}

function receiveHomes(builderId, json) {
  return {
    type: RECEIVE_HOMES,
    data: json.data._items.map(function (home) {
      return (0, _extends3.default)({}, home, {
        type: 'home'
      });
    }),
    receivedAt: Date.now(),
    builderId: builderId
  };
}

function fetchHomes(builderId) {
  return function (dispatch) {
    dispatch(requestHomes(builderId));
    var request = new _bdcoreUtilities.BuilderCloud('homes', {
      max_results: 9999,
      where: {
        isLot: { $ne: true },
        published: true,
        builder: builderId
      }
    });
    return request.getResource().then(function (json) {
      dispatch(receiveHomes(builderId, json));
    });
  };
}

function shouldFetchHomes(_ref, builderId) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var homes = _ref$cloudData.homes;

  var builderHomes = homes[builderId];

  if (!builderHomes) {
    return true;
  } else if (builderHomes.isFetching && isServer === builderHomes.requestedOnServer) {
    return false;
  } else if (!builderHomes.receivedAt) {
    return true;
  }

  return builderHomes.didInvalidate;
}

function fetchHomesIfNeeded() {
  var builderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _bdcoreUtilities.ConfigStore.getConfig('builder_id');

  return function (dispatch, getState) {
    if (shouldFetchHomes(getState(), builderId)) {
      return dispatch(fetchHomes(builderId));
    }
    return null;
  };
}

function addRecentHome(_id) {
  return {
    type: RECENT_HOME,
    _id: _id
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/actions.js
// module id = 341
// module chunks = 0